import sectionIconWithTextCss from '../css-snippets/section-icon-with-text';

const html = `
<style>${sectionIconWithTextCss}</style>
    <div data-attribute="icon-with-text-container">
        <div class="wrap-icon-with-text container">
            <div data-attribute="list-icon-with-text" class="list-icon-with-text">
                <div data-attribute="item-icon-with-text" class="item-icon-with-text">
                <div class="wrap-img">
                    <img loading="lazy" data-attribute="icon-item" class="icon-item" src="https://cdn.latteprint.com/latte/2025-10-06/1759746044832-Worldwide-shipping-icon.png" alt="">
                </div>
                <h2 data-attribute="title-item" class="title-item">Worldwide Shipping</h2>
                </div>
                <div data-attribute="item-icon-with-text" class="item-icon-with-text">
                <div class="wrap-img">
                    <img loading="lazy" data-attribute="icon-item" class="icon-item" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/06/image-68930259cc21a534f84cb3c9.png?w=50" alt="">
                </div>
                <h2 data-attribute="title-item" class="title-item">24/7 Customer Support</h2>
                </div>
                <div data-attribute="item-icon-with-text" class="item-icon-with-text">
                <div class="wrap-img">
                    <img loading="lazy" data-attribute="icon-item" class="icon-item" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/06/image-68930275f5b3cda1945e7510.png?w=50" alt="">
                </div>
                <h2 data-attribute="title-item" class="title-item">30 Day money back guarantee</h2>
                </div>
                <div data-attribute="item-icon-with-text" class="item-icon-with-text">
                <div class="wrap-img">
                    <img loading="lazy" data-attribute="icon-item" class="icon-item" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/06/image-689302948735692c8e1f00a0.png?w=50" alt="">
                </div>
                <h2 data-attribute="title-item" class="title-item">Over 12,000 happy customers</h2>
                </div>
            </div>
        </div>
    </div>
`;
export default html;
